import React from 'react';
import UpArrow from '../../../../public/images/long-arrow-up.svg';
import DownArrow from '../../../../public/images/long-arrow-down.svg';

const PercentageWithChange = ({ textValue }) => {
  const value = parseInt(textValue, 10);
  let arrow;
  if (value < 0) {
    arrow = <img src={DownArrow} alt="decrease" />;
  } else {
    arrow = <img src={UpArrow} alt="increase" />;
  }

  return (
    <div style={{ display: 'flex' }}>
      <div>{Math.abs(value)}%</div>
      <div className={`${value !== 0 ? 'block' : 'invisible'}`}>
        &nbsp;{arrow}
      </div>
    </div>
  );
};

export default PercentageWithChange;
